module.exports = __webpack_public_path__ + "static/media/sample_bulk_mll_vins_update.f0d44671.csv";